import React from 'react';
import CollapsiblePanel from '../CollapsiblePanel';
import Modal, {
  CloseModalButton,
  ModalPanel,
  OpenModalButton,
} from '../Modal';

const DiagnosticPanel = (props) => {
  return (
    <div className="diagnostic-panel">
      <CollapsiblePanel
        Id="diagnosticpanel"
        className="c-collapsible-panel"
        DefaultCollapsed={props.collapsed}
        Heading={props.panelHeading}
      >
        <Modal>
          <OpenModalButton
            open={'diagnostic-panel__tooltip'}
            id={'diagnostic-panel__tooltip'}
            className={'diagnostic-panel__modal-open'}
          >
            <span></span>
            <span />
          </OpenModalButton>
          <ModalPanel whenActive={'diagnostic-panel__tooltip'}>
            <div className={'diagnostic-panel__modal-panel'}>
              <CloseModalButton
                id={'diagnostic-panel__tooltip'}
                className={'diagnostic-panel__modal-close'}
              >
                <span className="show-for-sr">{props.Translations.close}</span>
              </CloseModalButton>
              <div className="diagnostic-panel__modal-panel__content">
                <h3>Information</h3>
                <div className="diagnostic-panel__modal-panel__description">
                  {props.infoBox && props.infoBox}
                </div>
              </div>
            </div>
          </ModalPanel>
        </Modal>

        <h2 className="diagnostic-panel__heading">{props.subHeading}</h2>
        {props.codeGroups.map((group, i) => {
          return (
            <div key={i} className="diagnostic-panel__code-group">
              <h2 className="diagnostic-panel__code-group__heading">
                {group.heading}
              </h2>
              <ul className="diagnostic-panel__code-group__wrapper">
                {group.codes && group.codes.map((item, key) => (
                  <li key={key}>
                    <div>{item.code}</div>
                    <div>{item.description}</div>
                  </li>
                ))}
              </ul>
            </div>
          );
        })}
      </CollapsiblePanel>
    </div>
  );
};

export default DiagnosticPanel;
